import React from 'react';

const VideoIcon = props => (
  <svg viewBox="0 0 20 14" {...props}>
    <g stroke="none" fillRule="nonzero">
      <g transform="translate(-342.000000, -1064.000000)">
        <g transform="translate(213.000000, 163.000000)">
          <g transform="translate(80.000000, 900.000000)">
            <path d="M69,3.55142232 L69,12.4398249 C69,13.1269147 68.2705001,13.5557987 67.6869002,13.214442 L64.0565655,11.0787746 L64.0565655,11.6870897 C64.0565655,13.5164114 62.6018569,15 60.8081454,15 L52.2484201,15 C50.4547086,15 49,13.5164114 49,11.6870897 L49,4.31291028 C49,2.48358862 50.4547086,1 52.2484201,1 L60.8124366,1 C62.6061481,1 64.0608567,2.48358862 64.0608567,4.31291028 L64.0608567,4.92122538 L67.6911914,2.78555799 C68.2705001,2.43544858 69,2.86870897 69,3.55142232 Z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default VideoIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/video-icon.js